export enum SettingsRoutes {
  EmailTemplates = "/settings/email-template",
  EmailAddress = "/settings/email-addresses",
  ForwardingAddresses = "/settings/email-addresses/forwarding",
  ReplyAddresses = "/settings/email-addresses/reply",
  CustomDomains = "/settings/email-addresses/domains",
  Integrations = "/settings/integrations",
  CustomFields = "/settings/custom-fields",
  CustomFieldsOpenCreateModal = "/settings/custom-fields#create",
  Tags = "/settings/tags",
  CannedResponses = "/settings/canned-responses",
  Apps = "/settings/integrations/apps",
  ContactForms = "/settings/contact-forms",
  WidgetForms = "/settings/widget-forms",
  MyViews = "/settings/my-views",
  Notifications = "/settings/notifications",
  Spam = "/settings/spam",
  OpenWidget = "/settings/openwidget",
  LiveChat = "/settings/livechat",
  /**
   * @deprecated Use `AutomationsRoutes.Rules` instead.
   */
  Workflows = "/settings/workflows",
}

export enum PreviewType {
  Desktop = "desktop",
  Mobile = "mobile",
}
